import { useCallback, useContext } from 'react';
import { Divider, Dot, Text, useResponsive } from '@bitrise/bitkit';
import { UserContext } from '@/models/User';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import useChangelog from '@/hooks/useChangelog';
import LinkItem from './LinkItem';

const AccountDrawer = ({ user }: { user: UserContext }): JSX.Element => {
  const { isMobile } = useResponsive();
  const { account } = useContext(GlobalPropsContext);

  const { hasUnreadTopics: changelogHasUnreadTopics } = useChangelog();

  const logout = useCallback(() => {
    window.Intercom?.('shutdown');
    window.location.href = '/users/sign_out';
  }, []);

  return (
    <>
      <Text paddingX="24">{user.email}</Text>
      <Divider marginY="24" />
      <LinkItem iconName="Person" href="/me/account">
        Account settings
      </LinkItem>
      <LinkItem iconName="ConnectedAccounts" href="/me/account/apple-id">
        Connected accounts
      </LinkItem>
      {isMobile && (
        <>
          {account && (
            <LinkItem iconName="Bell" href="/activity">
              Notifications
            </LinkItem>
          )}
          <Divider marginY="24" />
          <Text fontWeight="bold" size="1" textTransform="uppercase" color="neutral.60" paddingX="24" marginBottom="8">
            Help
          </Text>
          <LinkItem iconName="News" href="https://bitrise.io/changelog" position="relative">
            {changelogHasUnreadTopics && (
              <Dot size={8} backgroundColor="icon/negative" position="absolute" top="12" left="40" />
            )}
            Changelog
          </LinkItem>
          <LinkItem iconName="Doc" isExternal href="https://devcenter.bitrise.io" title="Answers to your questions">
            Documentation
          </LinkItem>
          <LinkItem iconName="Chat" isExternal href="https://discuss.bitrise.io/" title="Ask your fellow developers">
            Community forum
          </LinkItem>
          <LinkItem iconName="Support" isExternal href="https://support.bitrise.io/hc/en-us" title="Support center">
            Support Center
          </LinkItem>
        </>
      )}
      <Divider marginY="24" />
      <LinkItem as="button" iconName="Logout" onClick={logout} width="100%">
        Logout
      </LinkItem>
    </>
  );
};

export default AccountDrawer;
